import Vue from "vue";
import Vuetify from "vuetify/lib";
import { Ripple } from "vuetify/lib/directives";

Vue.use(Vuetify);
Vue.directive("ripple", Ripple);

export default new Vuetify({
    directives: {
        Ripple
    },
    icons: {
        iconfont: "mdi"
    }
});
